import type { Dayjs } from "dayjs";

import dayjs from "@/utils/dayjs";

import { toDayjs } from "./dateConvertFormatUtills";

const getDayBetween = (start: Date | Dayjs, end: Date | Dayjs): number => {
  try {
    const dateStart = toDayjs(start || dayjs()); // Convert to Dayjs
    const dateEnd = toDayjs(end || dayjs()); // Convert to Dayjs

    const difference = dateEnd
      .startOf("day")
      .diff(dateStart.startOf("day"), "day");
    return Math.ceil(difference); // Return the absolute difference
  } catch (error) {
    return 0;
  }
};

export function flyAcrossTheDay(startDate?: string, endDate?: string): number {
  try {
    if (!startDate || !endDate) return 0;

    const startDateTime = dayjs(startDate).date(); // Get the day of the month from start date
    const endDateTime = dayjs(endDate).date(); // Get the day of the month from end date
    const diffDate = endDateTime - startDateTime; // Calculate the difference
    return diffDate;
  } catch (error) {
    return 0;
  }
}

export function isTimeBetween(
  date: number | Date | string | Dayjs,
  startHour: [number, number] = [0, 0],
  endHour: [number, number] = [0, 59],
): boolean {
  const inputDate = toDayjs(date); // Convert to Dayjs
  const hours = inputDate.hour(); // Get hours
  const minutes = inputDate.minute(); // Get minutes

  const isAfterStartHour =
    hours > startHour[0] || (hours === startHour[0] && minutes >= startHour[1]);
  const isBeforeEndHour =
    hours < endHour[0] || (hours === endHour[0] && minutes <= endHour[1]);

  // Handle cases where the time range spans midnight
  if (
    startHour[0] > endHour[0] ||
    (startHour[0] === endHour[0] && startHour[1] > endHour[1])
  ) {
    return isAfterStartHour || isBeforeEndHour;
  }

  return isAfterStartHour && isBeforeEndHour;
}

export default getDayBetween;
